export default __webpack_public_path__ + "static/gs-6-explainmodel--mobile-953dfaf519911708253cc04c4d29b05d.jpg";